import PropTypes from 'prop-types';
import React from 'react';
import { TabPane } from 'reactstrap';
import FollowupCard from './followupCard';
const FollowupsTab = ({
  followupsArray,
  content: _content = null,
  path: _path = '',
  formActions: _formActions = null,
  reduxEntity: _reduxEntity = '',
  pendingOperation: _pendingOperation = false,
  notificationActions: _notificationActions = null
}) => /*#__PURE__*/React.createElement(TabPane, {
  tabId: "followups"
}, /*#__PURE__*/React.createElement("div", {
  className: "px-3"
}, followupsArray.map(followup => /*#__PURE__*/React.createElement(FollowupCard, {
  key: followup.id,
  followupId: followup.id,
  followup: followup,
  content: _content,
  path: _path,
  formActions: _formActions,
  reduxEntity: _reduxEntity,
  pendingOperation: _pendingOperation,
  notificationActions: _notificationActions
}))));
FollowupsTab.propTypes = {
  followupsArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  path: PropTypes.string,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }),
  reduxEntity: PropTypes.string,
  pendingOperation: PropTypes.bool,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  })
};
export default FollowupsTab;